/**
 * Active Filters Bar Component
 * Displays currently active filters as removable chips
 */

import React from 'react';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';

const ActiveFiltersBar = ({ filters, onRemoveFilter }) => {
  const getFilterChips = () => {
    const chips = [];

    if (filters.classification) {
      chips.push({
        key: 'classification',
        label: `Classification: ${filters.classification.replace('_', ' ')}`,
        value: filters.classification
      });
    }

    if (filters.department && filters.department !== 'all') {
      chips.push({
        key: 'department',
        label: `Department: ${filters.department}`,
        value: filters.department
      });
    }

    if (filters.minRiskScore) {
      chips.push({
        key: 'minRiskScore',
        label: `Min Risk: ${filters.minRiskScore}`,
        value: filters.minRiskScore
      });
    }

    if (filters.maxRiskScore) {
      chips.push({
        key: 'maxRiskScore',
        label: `Max Risk: ${filters.maxRiskScore}`,
        value: filters.maxRiskScore
      });
    }

    return chips;
  };

  const chips = getFilterChips();

  if (chips.length === 0) {
    return null;
  }

  return (
    <Box sx={{ mb: 3, display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 1 }}>
      <Typography sx={{ fontWeight: 500, mr: 1 }}>Active Filters:</Typography>
      {chips.map((chip) => (
        <Chip
          key={chip.key}
          label={chip.label}
          color="primary"
          onDelete={() => onRemoveFilter(chip.key)}
          sx={{ fontSize: '0.9rem' }}
        />
      ))}
    </Box>
  );
};

export default ActiveFiltersBar;
